import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dreamy%20abstract%20lifestyle%20collage%20with%20soft%20pastel%20peach%20cream%20and%20warm%20sand%20tones%2C%20flowing%20organic%20shapes%20and%20gentle%20textile%20textures%2C%20artistic%20editorial%20background%20with%20subtle%20fashion%20elements%2C%20ethereal%20atmospheric%20composition%2C%20clean%20modern%20design%20with%20elegant%20warmth&width=1600&height=900&seq=hero-bg-v3&orientation=landscape"
          alt="Kakobuy Spreadsheet Polska"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-black/20"></div>
      </div>

      <div className="relative w-full px-6 md:px-10 py-24 md:py-32">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="w-full">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/80 backdrop-blur-sm rounded-full mb-6">
                <span className="w-2 h-2 bg-primary-500 rounded-full animate-pulse"></span>
                <span className="text-xs font-medium text-foreground-800">Kakobuy Spreadsheet 2026</span>
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-[1.1] mb-6 tracking-tight">
                {t('hero.title')}
              </h1>
              <p className="text-base md:text-lg text-background-50/80 leading-relaxed mb-8 max-w-lg">
                {t('hero.subtitle')}
              </p>
              <div className="flex flex-col sm:flex-row items-start gap-3">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="group inline-flex items-center gap-2 px-6 py-3.5 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
                >
                  <span>{t('hero.cta_primary')}</span>
                  <span className="w-7 h-7 flex items-center justify-center bg-background-50/20 rounded-full group-hover:translate-x-0.5 transition-transform">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="group inline-flex items-center gap-2 px-6 py-3.5 border border-background-50/30 text-background-50 font-medium rounded-full hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
                >
                  <span>{t('hero.cta_secondary')}</span>
                  <i className="ri-arrow-right-up-line text-sm group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
                </a>
              </div>
            </div>

            <div className="hidden lg:block w-full">
              <div className="relative">
                <div className="rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20lifestyle%20product%20flat%20lay%20with%20trendy%20sneakers%20handbag%20and%20delicate%20accessories%20on%20warm%20cream%20linen%20surface%2C%20soft%20natural%20window%20light%20from%20upper%20left%2C%20editorial%20fashion%20photography%2C%20clean%20harmonious%20composition%20with%20organic%20textures%2C%20contemporary%20Scandinavian%20aesthetic&width=800&height=600&seq=hero-side-v3&orientation=landscape"
                    alt="Kakobuy Finds produkty"
                    className="w-full h-auto rounded-2xl"
                  />
                </div>
                <div className="absolute -bottom-4 -left-4 bg-background-50 rounded-xl px-4 py-3 shadow-sm">
                  <p className="text-xs font-medium text-foreground-700">Najlepsze Kakobuy Finds</p>
                  <p className="text-lg font-bold text-primary-500">1000+ produktów</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}